import React, {
  useState,
  createContext,
  useContext,
  useEffect,
} from 'react'
import axios from 'axios'
import localConfig from '../../config/local-config'
import apiConfig from '../../config/api-config'

import { LocalContext } from '../helpers/useLocalContext'
import useIsMounted from '../../hooks/useIsMounted'

export const RelatedPartsContext = createContext()

export default function RelatedPartsProvider({
  children,
  attribute = {},
  limit = 3,
  topLevel = '',
  secondLevel = '',
  pageType,
  relatedParts,
}) {
  const isMounted = useIsMounted()
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  const [relatedPartsContent, setRelatedPartsContent] = useState(null)
  const relatedPartsRequest = `${apiConfig.apiURL}/v1/relatedparts`
  const part = attribute?.part || ''
  const year = attribute?.year || ''
  const make = attribute?.make || ''
  const model = attribute?.model || ''

  useEffect(() => {
    if (isBot || relatedPartsContent || relatedParts || !isMounted()) return

    axios.get(relatedPartsRequest, {
      params: {
        domain: localConfig.hostname,
        topLevel,
        secondLevel,
        part,
        year,
        make,
        model,
      },
      headers: {
        apikey: apiConfig.apiKey,
      },
    }).then(res => {
      if (!isMounted()) return

      const { data: responseData } = res
      setRelatedPartsContent(responseData.data.relatedParts || [])
    })
  }, [
    relatedParts,
    relatedPartsContent,
    relatedPartsRequest,
    isBot,
    limit,
    pageType,
    topLevel,
    secondLevel,
    part,
    year,
    make,
    model,
    isMounted,
  ])

  return (
    <RelatedPartsContext.Provider value={relatedPartsContent}>
      {children}
    </RelatedPartsContext.Provider>
  )
}
